import { priceStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrice";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import merge from "lodash/merge";
import { css } from "styled-components";

Object.assign(priceStyles, {
    productPrice: {
        price: {
            priceText: {
                size: 20,
                css: css`
                    color: ${COLORS.link.base};
                `,
            },
            unitOfMeasureText: { size: 20 },
        },
    },
});
